import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const DuelNotification = ({ notification, onClose, onAccept }) => {
  const [responding, setResponding] = useState(false);

  const handleResponse = async (action) => {
    setResponding(true);
    try {
      const response = await apiClient.post('/duels/respond-notification', {
        duel_id: notification.duel_id,
        action: action
      });

      if (action === 'accept_now' && response.data.redirect) {
        // Navigate to duel game immediately
        window.location.href = response.data.redirect;
      } else {
        toast.success(response.data.message);
        onAccept(action);
      }
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al responder al duelo');
    } finally {
      setResponding(false);
    }
  };

  const handleClose = () => {
    // Auto-accept as "later" when closed
    handleResponse('accept_later');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md mx-4 border-4 border-green-500 animate-bounce">
        {/* Header with Logo */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-green-600">⚔️ ¡Reto de Duelo!</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
            disabled={responding}
          >
            ×
          </button>
        </div>

        {/* Challenger Info */}
        <div className="text-center mb-6">
          <div className="mb-4">
            {notification.challenger.profile_image ? (
              <img
                src={notification.challenger.profile_image}
                alt={notification.challenger.name}
                className="w-20 h-20 rounded-full object-cover mx-auto border-4 border-green-400 shadow-lg"
              />
            ) : (
              <div className="w-20 h-20 rounded-full bg-green-600 flex items-center justify-center mx-auto border-4 border-green-400 shadow-lg">
                <span className="text-2xl font-bold text-white">
                  {notification.challenger.name.charAt(0).toUpperCase()}
                </span>
              </div>
            )}
          </div>

          <p className="text-lg text-gray-800 mb-2">
            <strong>{notification.message}</strong>
          </p>
          <p className="text-sm text-gray-600">
            {notification.challenger.name} te desafía a un duelo de 5 preguntas
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => handleResponse('accept_now')}
            disabled={responding}
            className="w-full bg-gradient-to-r from-green-500 to-teal-500 hover:from-green-600 hover:to-teal-600 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 flex items-center justify-center space-x-2"
          >
            {responding ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Accediendo...</span>
              </>
            ) : (
              <>
                <span>⚡</span>
                <span>Contestar Ahora</span>
              </>
            )}
          </button>

          <button
            onClick={() => handleResponse('accept_later')}
            disabled={responding}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-all duration-200 flex items-center justify-center space-x-2"
          >
            <span>📝</span>
            <span>Contestar Después</span>
          </button>
        </div>

        {/* Footer */}
        <p className="text-xs text-gray-500 text-center mt-4">
          El reto estará disponible en "Retos Pendientes" hasta que lo contestes
        </p>
      </div>
    </div>
  );
};

export default DuelNotification;